import { render, staticRenderFns } from "./TDControlAlerts.vue?vue&type=template&id=2498d3ec"
import script from "./TDControlAlerts.vue?vue&type=script&lang=js"
export * from "./TDControlAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports